// Copyright (c) 2025, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import React from "react";
import { Box, Button, Typography } from "@mui/material";
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
} from "react-router-dom";

const Link = React.forwardRef<HTMLAnchorElement, RouterLinkProps>(function Link(
  itemProps,
  ref
) {
  return <RouterLink ref={ref} {...itemProps} role={undefined} />;
});

export default function ExamAlreadySubmitted() {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <img src="/error-occurred.svg" alt="Conflict occurred" height={200} />
      <Typography
        sx={{ mt: 5, fontWeight: "bold" }}
        variant="h4"
        style={{ color: "gray" }}
      >
        Oops! Something went wrong.
      </Typography>
      <Typography variant="h6" style={{ color: "gray" }}>
        You have already submitted the exam.
      </Typography>
      <Button sx={{ mt: 5 }} component={Link} to={"/"} variant="outlined">
        Back Home
      </Button>
    </Box>
  );
}
